// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "fc6253d33ac5e60af82b9c815c3a98f7" + ".js";
};